module.exports = __webpack_public_path__ + "static/1281479807-wide.997a4a05.jpg";